import React from 'react'


const MinusCircle = ({ title = 'Исключить', className = '', size, variant, rotate = false, onClick }) => {
    return (
        <i className={ `${className} spp-svg ${variant ? 'spp-svg-color-' + variant : ''} ${size ? 'spp-svg-size-' + size : ''} ${rotate === true ? 'rotate' : ''}` } onClick={ onClick }>
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <title>{ title }</title>
                <g strokeWidth="1.188"><path d="M12 2c5.514 0 10 4.486 10 10s-4.486 10-10 10-10-4.486-10-10 4.486-10 10-10zm0-2c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm6 13h-12v-2h12v2z" /><circle cx="9.5" cy="9.5" r="9.5" stroke="none" transform="scale(.2228)" data-name="Ellipse 719" fill="none" /></g></svg>
        </i>
    )
}

export default MinusCircle